// The source of truth for these values is in _variables.scss:
export const responsiveBreakpointsPx = {
    sm: 0,
    md: 768,
    lg: 1024,
    xl: 1440,
    'nav-tablet': 1140,
};